/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backgrid from 'backgrid';

/**
  Formatter to convert any value to string.

  @class Backgrid.StringFormatter
  @extends Backgrid.CellFormatter
  @constructor
 */
const StringFormatter = function () {};
StringFormatter.prototype = new Backgrid.CellFormatter();
Object.assign(StringFormatter.prototype, {
  /**
    Converts any value to a string using Ecmascript's implicit type
    conversion. If the given value is `null` or `undefined`, an empty string is
    returned instead.

    @member Backgrid.StringFormatter
    @param {*} rawValue
    @param {Backbone.Model} model Used for more complicated formatting
    @return {string}
   */
  toRaw(formattedData) {
    return formattedData !== '--' ? formattedData : '';
  },
  fromRaw(rawValue, model) {
    if (_.isNil(rawValue) || rawValue === '') {
      return '--';
    }
    return `${rawValue}`;
  },
});

export default StringFormatter;
